import { number } from 'prop-types';
import React from 'react';
import { MdAttachFile } from 'react-icons/md';

const CommentAttachmentsLabel = ({ count }) => (
  <div className="text-nowrap">
    <MdAttachFile />{' '}
    {count ? <span className="notification-blip">{count}</span> : ''}
  </div>
);

CommentAttachmentsLabel.propTypes = {
  count: number.isRequired,
};

export default CommentAttachmentsLabel;
